<template>
  <div class="scores-container">
    <div class="trading-journal">
      <div class="risk-score-card">
        <i class="fas fa-book risk-icon"> Trading Journal</i>
      </div>
      <table>
        <thead>
          <tr>
            <th>Trade #</th>
            <th>Action</th>
            <th>Opening Date</th>
            <th>Closing Date</th>
            <th>Symbol</th>
            <th>Cost Basis</th>
            <th>Unrealized PnL</th>
            <th>Realized PnL</th>
            <th>Outcome</th>
            <th>Market Commentary</th>
            <th>Lessons Learned</th>
            <th>Status</th>

          </tr>
        </thead>
  

        <tbody>
          <tr v-for="(trade, index) in trades" :key="index">
            <td data-label="Trade #">{{ trade.trade_number }}</td>
  <td data-label="Action">{{ trade.action }}</td>
  <td data-label="Opening Date">{{ trade.opening_date }}</td>
  <td data-label="Closing Date">{{ trade.closing_date }}</td>
  <td data-label="Symbol">{{ trade.symbol }}</td>
  <td data-label="Cost Basis">{{ trade.cost_basis }}</td>
  <td data-label="Unrealized PnL">{{ trade.unrealized_pnl }}</td>
  <td data-label="Realized PnL">{{ trade.realized_pnl }}</td>
  <td data-label="Outcome">{{ trade.outcome }}</td>
  <td data-label="Market Commentary">{{ trade.market_commentary }}</td>
  <td data-label="Lessons Learned">{{ trade.lessons_learned }}</td>
  <td data-label="Status">{{ trade.status }}</td>
     

            <td>
                <button @click="prepareEditTrade(trade)">Edit</button>
              <button @click="deleteTrade(trade.id)">Delete</button>
            </td>
          </tr>
          <tr>
 

  </tr>
        </tbody>
      </table>
      <button @click="openAddNewTradeForm">Add New Trade</button></div>   
      <!-- Form for Adding/Editing Trades -->
      <div v-if="showAddTradeForm" class="trade-form">
      <h3>{{ isEditing ? 'Edit Trade' : 'Add New Trade' }}</h3>
      <input type="text" v-model="formTrade.symbol" placeholder="Symbol">
      <input type="date" v-model="formTrade.opening_date" placeholder="Opening Date">
      <input type="date" v-model="formTrade.closing_date" placeholder="Closing Date">
      <select v-model="formTrade.action">
        <option value="buy">Buy</option>
        <option value="sell">Sell</option>
        <option value="short">Short</option>
    </select>
    <select v-model="formTrade.status">
        <option value="open">Open</option>
        <option value="closed">Closed</option>
      </select>
      <input type="number" v-model="formTrade.cost_basis" placeholder="Cost Basis">
      <input type="number" v-model="formTrade.unrealized_pnl" placeholder="Unrealized PnL">
      <input type="number" v-model="formTrade.realized_pnl" placeholder="Realized PnL">
      <select v-model="formTrade.outcome">
        <option value="winner">Winner</option>
        <option value="loser">Loser</option>
        <option value="neutral">neutral</option>
            </select>
      <input type="text" v-model="formTrade.market_commentary" placeholder="Market Commentary">
      <input type="text" v-model="formTrade.lessons_learned" placeholder="Lessons Learned">

      <button @click="isEditing ? submitEditTrade() : submitNewTrade()">Save Changes</button>
      <button @click="showAddTradeForm = false">Cancel</button>
   
    </div></div><br><br>
  </template>
  
  <script>
import { ref, onMounted, computed} from 'vue';
import axios from 'axios';
import { Auth } from 'aws-amplify';

export default {
  setup() {
    const trades = ref([]);
    const formTrade = ref({
      action: '',
      opening_date: '',
      closing_date: '',
      symbol: '',
      status: '',
      cost_basis: '',
      closing_proceeds: '',
      unrealized_pnl: '',
      realized_pnl: '',
      outcome: '',
      market_commentary: '',
      lessons_learned: ''
    });


    const formatDate = (date) => {
  return date ? new Date(date).toISOString().substring(0, 10) : '';
};
    const totalRiskCapital = computed(() => {
    return trades.value.reduce((total, trade) => total + trade.total_risk_capital, 0);
  });

  const totalProfitability = computed(() => {
    return trades.value.reduce((total, trade) => total + trade.profitability, 0);
  });
    const showAddTradeForm = ref(false);
    const isEditing = ref(false);

    const openAddNewTradeForm = () => {
  resetForm();
  showAddTradeForm.value = true;
  isEditing.value = false;
};

const resetAndHideForm = () => {
  resetForm();
  isEditing.value = false;
  showAddTradeForm.value = false;
};
    
const resetForm = () => {
  formTrade.value = {
    action: '',
    opening_date: '',
    closing_date: '',
    symbol: '',
    status: '',
    cost_basis: '',
    closing_proceeds: '',
    unrealized_pnl: '',
    realized_pnl: '',
    outcome: '',
    market_commentary: '',
    lessons_learned: ''
  };
};



    const fetchTrades = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const response = await axios.get('https://api.riskypaws.com/frontoffice/api/tradejournal/', {
          headers: { 'X-Cognito-Sub': cognitoSub }
        });
        trades.value = response.data;
      } catch (error) {
        console.error('Error fetching trades:', error);
      }
    };

    const submitNewTrade = async () => {
  const tradeData = {
    ...formTrade.value,
    opening_date: formatDate(formTrade.value.opening_date),
    closing_date: formatDate(formTrade.value.closing_date)
  };

  try {
    const user = await Auth.currentAuthenticatedUser();
    const cognitoSub = user.attributes.sub;
    await axios.post('https://api.riskypaws.com/frontoffice/api/tradejournal/', tradeData, {
      headers: { 'X-Cognito-Sub': cognitoSub }
    });
    resetAndHideForm();
    fetchTrades();
  } catch (error) {
    console.error('Error adding trade:', error);
  }
};

const submitEditTrade = async () => {
  const tradeData = {
    ...formTrade.value,
    opening_date: formatDate(formTrade.value.opening_date),
    closing_date: formatDate(formTrade.value.closing_date)
  };

  try {
    const user = await Auth.currentAuthenticatedUser();
    const cognitoSub = user.attributes.sub;
    await axios.put(`https://api.riskypaws.com/frontoffice/api/tradejournal/${formTrade.value.id}/`, tradeData, {
      headers: { 'X-Cognito-Sub': cognitoSub }
    });
    resetAndHideForm();
    fetchTrades(); // Refresh the list of trades
  } catch (error) {
    console.error('Error editing trade:', error);
  }
};

    const deleteTrade = async (tradeId) => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        await axios.delete(`https://api.riskypaws.com/frontoffice/api/tradejournal/${tradeId}/`, {
          headers: { 'X-Cognito-Sub': cognitoSub }
        });
        fetchTrades();
      } catch (error) {
        console.error('Error deleting trade:', error);
      }
    };

    const prepareEditTrade = (trade) => {
  formTrade.value = { ...trade };
  isEditing.value = true;
  showAddTradeForm.value = true;
};


    onMounted(() => {
      fetchTrades();
    });

    return {
      trades,
      formTrade,
      showAddTradeForm,
      isEditing,
      submitNewTrade,
      submitEditTrade,
      deleteTrade,
      prepareEditTrade,
      resetAndHideForm,
      totalRiskCapital,
    totalProfitability,
    openAddNewTradeForm,
    };
  }
};
</script>

<style scoped>
.trading-journal {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  border: 2px solid #4A148C; /* Match the border color */
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
  background-color: white; /* Background color */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Box shadow */
}

.trading-journal .risk-score-card {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  background-color: #36454f;
  color: white;
  font-size: 24px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.trading-journal table {
  width: 100%;
  border-collapse: collapse;
}

.trading-journal th, .trading-journal td {
  border: 1px solid #4A148C; /* Border color to match Subscription Tracker */
  padding: 8px;
  text-align: left;
}

.trading-journal th {
  background-color: #f4f4f4; /* Header background */
  color: #333; /* Header text color */
}

.trading-journal td {
  background-color: #fff; /* Cell background */
}

.trading-journal button {
  background-color: #4A148C; /* Purple background */
  color: white; /* White text */
  border: none;
  border-radius: 20px; /* Rounded corners */
  padding: 10px 20px; /* Padding inside the button */
  cursor: pointer; /* Cursor style */
  transition: background-color 0.3s ease; /* Smooth transition for hover effect */
}

.trading-journal button:hover {
  background-color: black; /* Black background on hover */
}

@media (max-width: 768px) {
  /* Responsive styles if needed */
}

@media (max-width: 768px) {
  .trading-journal table, 
  .trading-journal thead, 
  .trading-journal tbody, 
  .trading-journal th, 
  .trading-journal td, 
  .trading-journal tr {
    display: block;
    width: 100%;
  }

  .trading-journal th {
    display: none; /* Hide table headers on small screens */
  }

  .trading-journal td {
    margin-bottom: 10px; /* Space out table cells */
    border-bottom: 1px solid #ddd; /* Optional: add a bottom border to each cell */
  }

  .trading-journal td:before {
    content: attr(data-label); /* Use data-label attribute to display the label */
    float: left;
    font-weight: bold;
    color: #4A148C; /* Optional: Color for labels */
    margin-right: 10px; /* Space between label and cell content */
  }

  /* Adjust button sizes if necessary */
  .trading-journal button {
    padding: 5px 10px; /* Smaller padding for buttons */
    font-size: 0.8rem; /* Smaller font size for buttons */
  }
}
</style>